export const mockResponseString = {
	isMock:true,
    "errorMessage": "",
    "status": "success",
    "offices": [
        "GB",
        "MY",
        "NZ",
        "AU",
        "SG",
        "US",
        "IN",
        "DE",
        "FR",
        "ES",
        "CH",
        "CA",
        "MX",
        "WO",
        "EM",
        "BR",
        "JP",
        "KR",
        "IT"
    ],
    "matches": [
        {
            "NiceClass": 30,
            "term": "sushi",
            "nbTotalOccurences": 18122,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 5983
                },
                {
                    "office": "MY",
                    "value": 544
                },
                {
                    "office": "NZ",
                    "value": 409
                },
                {
                    "office": "AU",
                    "value": 827
                },
                {
                    "office": "SG",
                    "value": 937
                },
                {
                    "office": "US",
                    "value": 913
                },
                {
                    "office": "IN",
                    "value": 95
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 1
                },
                {
                    "office": "CA",
                    "value": 91
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 3080
                },
                {
                    "office": "EM",
                    "value": 5238
                },
                {
                    "office": "BR",
                    "value": 4
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 2,
            "typeString": "nice",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "sushi",
            "highlighted": "<em>sushi</em>"
        },
        {
            "NiceClass": 43,
            "term": "sushi restaurant services",
            "nbTotalOccurences": 2533,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 1462
                },
                {
                    "office": "MY",
                    "value": 64
                },
                {
                    "office": "NZ",
                    "value": 48
                },
                {
                    "office": "AU",
                    "value": 10
                },
                {
                    "office": "SG",
                    "value": 174
                },
                {
                    "office": "US",
                    "value": 178
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 1
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 58
                },
                {
                    "office": "EM",
                    "value": 538
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 1,
            "typeString": "mgs",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "sushi restaurant services",
            "highlighted": "<em>sushi</em> restaurant services"
        },
        {
            "NiceClass": 21,
            "term": "sushi rolling mats",
            "nbTotalOccurences": 2346,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 1390
                },
                {
                    "office": "MY",
                    "value": 2
                },
                {
                    "office": "NZ",
                    "value": 2
                },
                {
                    "office": "AU",
                    "value": 11
                },
                {
                    "office": "SG",
                    "value": 5
                },
                {
                    "office": "US",
                    "value": 99
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 6
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 22
                },
                {
                    "office": "EM",
                    "value": 809
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 1,
            "typeString": "mgs",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "sushi rolling mats",
            "highlighted": "<em>sushi</em> rolling mats"
        },
        {
            "NiceClass": 21,
            "term": "hand operated sushi makers",
            "nbTotalOccurences": 2328,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 1450
                },
                {
                    "office": "MY",
                    "value": 1
                },
                {
                    "office": "NZ",
                    "value": 5
                },
                {
                    "office": "AU",
                    "value": 10
                },
                {
                    "office": "SG",
                    "value": 9
                },
                {
                    "office": "US",
                    "value": 58
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 22
                },
                {
                    "office": "EM",
                    "value": 773
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "hand operated sushi makers",
            "highlighted": "hand operated <em>sushi</em> makers"
        },
        {
            "NiceClass": 21,
            "term": "sushi rolling equipment",
            "nbTotalOccurences": 2164,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 1335
                },
                {
                    "office": "MY",
                    "value": 0
                },
                {
                    "office": "NZ",
                    "value": 0
                },
                {
                    "office": "AU",
                    "value": 1
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 1
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 6
                },
                {
                    "office": "EM",
                    "value": 821
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "sushi rolling equipment",
            "highlighted": "<em>sushi</em> rolling equipment"
        },
        {
            "NiceClass": 43,
            "term": "sushi bars",
            "nbTotalOccurences": 103,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 31
                },
                {
                    "office": "MY",
                    "value": 11
                },
                {
                    "office": "NZ",
                    "value": 6
                },
                {
                    "office": "AU",
                    "value": 8
                },
                {
                    "office": "SG",
                    "value": 22
                },
                {
                    "office": "US",
                    "value": 2
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 1
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 6
                },
                {
                    "office": "EM",
                    "value": 16
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "sushi bars",
            "highlighted": "<em>sushi</em> bars"
        },
        {
            "NiceClass": 30,
            "term": "'sushi'",
            "nbTotalOccurences": 82,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 30
                },
                {
                    "office": "MY",
                    "value": 0
                },
                {
                    "office": "NZ",
                    "value": 0
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 0
                },
                {
                    "office": "EM",
                    "value": 52
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "'sushi'",
            "highlighted": "'<em>sushi</em>'"
        },
        {
            "NiceClass": 43,
            "term": "providing sushi",
            "nbTotalOccurences": 55,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 2
                },
                {
                    "office": "MY",
                    "value": 7
                },
                {
                    "office": "NZ",
                    "value": 4
                },
                {
                    "office": "AU",
                    "value": 9
                },
                {
                    "office": "SG",
                    "value": 9
                },
                {
                    "office": "US",
                    "value": 6
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 18
                },
                {
                    "office": "EM",
                    "value": 0
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "providing sushi",
            "highlighted": "providing <em>sushi</em>"
        },
        {
            "NiceClass": 35,
            "term": "retail services in relation to sushi",
            "nbTotalOccurences": 54,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 15
                },
                {
                    "office": "MY",
                    "value": 0
                },
                {
                    "office": "NZ",
                    "value": 0
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 6
                },
                {
                    "office": "EM",
                    "value": 33
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "retail services in relation to sushi",
            "highlighted": "retail services in relation to <em>sushi</em>"
        },
        {
            "NiceClass": 43,
            "term": "sushi takeaway services",
            "nbTotalOccurences": 47,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 23
                },
                {
                    "office": "MY",
                    "value": 0
                },
                {
                    "office": "NZ",
                    "value": 0
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 6
                },
                {
                    "office": "EM",
                    "value": 18
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "sushi takeaway services",
            "highlighted": "<em>sushi</em> takeaway services"
        },
        {
            "NiceClass": 35,
            "term": "wholesale services in relation to sushi",
            "nbTotalOccurences": 44,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 11
                },
                {
                    "office": "MY",
                    "value": 0
                },
                {
                    "office": "NZ",
                    "value": 0
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 4
                },
                {
                    "office": "EM",
                    "value": 29
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "wholesale services in relation to sushi",
            "highlighted": "wholesale services in relation to <em>sushi</em>"
        },
        {
            "NiceClass": 30,
            "term": "sushi, tabbouleh",
            "nbTotalOccurences": 43,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 4
                },
                {
                    "office": "MY",
                    "value": 0
                },
                {
                    "office": "NZ",
                    "value": 1
                },
                {
                    "office": "AU",
                    "value": 3
                },
                {
                    "office": "SG",
                    "value": 2
                },
                {
                    "office": "US",
                    "value": 2
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 30
                },
                {
                    "office": "EM",
                    "value": 0
                },
                {
                    "office": "BR",
                    "value": 1
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "sushi, tabbouleh",
            "highlighted": "<em>sushi</em>, tabbouleh"
        },
        {
            "NiceClass": 30,
            "term": "spring rolls, sushi",
            "nbTotalOccurences": 43,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 19
                },
                {
                    "office": "MY",
                    "value": 0
                },
                {
                    "office": "NZ",
                    "value": 3
                },
                {
                    "office": "AU",
                    "value": 1
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 1
                },
                {
                    "office": "EM",
                    "value": 19
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "spring rolls, sushi",
            "highlighted": "spring rolls, <em>sushi</em>"
        },
        {
            "NiceClass": 43,
            "term": "sushi-bars",
            "nbTotalOccurences": 43,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 0
                },
                {
                    "office": "MY",
                    "value": 12
                },
                {
                    "office": "NZ",
                    "value": 0
                },
                {
                    "office": "AU",
                    "value": 2
                },
                {
                    "office": "SG",
                    "value": 23
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 6
                },
                {
                    "office": "EM",
                    "value": 0
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "sushi-bars",
            "highlighted": "<em>sushi</em>-bars"
        },
        {
            "NiceClass": 30,
            "term": "sushi vinegar",
            "nbTotalOccurences": 41,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 8
                },
                {
                    "office": "MY",
                    "value": 1
                },
                {
                    "office": "NZ",
                    "value": 1
                },
                {
                    "office": "AU",
                    "value": 3
                },
                {
                    "office": "SG",
                    "value": 3
                },
                {
                    "office": "US",
                    "value": 10
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 6
                },
                {
                    "office": "EM",
                    "value": 9
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "sushi vinegar",
            "highlighted": "<em>sushi</em> vinegar"
        },
        {
            "NiceClass": 30,
            "term": "powdered sushi seasoning mixes",
            "nbTotalOccurences": 40,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 7
                },
                {
                    "office": "MY",
                    "value": 2
                },
                {
                    "office": "NZ",
                    "value": 2
                },
                {
                    "office": "AU",
                    "value": 2
                },
                {
                    "office": "SG",
                    "value": 6
                },
                {
                    "office": "US",
                    "value": 9
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 2
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 2
                },
                {
                    "office": "EM",
                    "value": 8
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "powdered sushi seasoning mixes",
            "highlighted": "powdered <em>sushi</em> seasoning mixes"
        },
        {
            "NiceClass": 43,
            "term": "sashimi and sushi bar",
            "nbTotalOccurences": 34,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 0
                },
                {
                    "office": "MY",
                    "value": 3
                },
                {
                    "office": "NZ",
                    "value": 0
                },
                {
                    "office": "AU",
                    "value": 8
                },
                {
                    "office": "SG",
                    "value": 22
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 1
                },
                {
                    "office": "EM",
                    "value": 0
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "sashimi and sushi bar",
            "highlighted": "sashimi and <em>sushi</em> bar"
        },
        {
            "NiceClass": 35,
            "term": "online retail services in relation to sushi",
            "nbTotalOccurences": 34,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 5
                },
                {
                    "office": "MY",
                    "value": 0
                },
                {
                    "office": "NZ",
                    "value": 0
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 6
                },
                {
                    "office": "EM",
                    "value": 23
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "online retail services in relation to sushi",
            "highlighted": "online retail services in relation to <em>sushi</em>"
        },
        {
            "NiceClass": 35,
            "term": "retailing and wholesaling in shops, via global computer networks, via catalogue, via post, via telephone, via radio and television and via other electronic media of preparations for stiffening whipped cream, sushi, natural sweeteners, thickening agents for cooking foodstuffs, wheat germ for human consumption, raw and unprocessed agricultural, aquacultural, horticultural and forestry products, live animals, fresh fruits and vegetables",
            "nbTotalOccurences": 32,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 16
                },
                {
                    "office": "MY",
                    "value": 0
                },
                {
                    "office": "NZ",
                    "value": 0
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 0
                },
                {
                    "office": "EM",
                    "value": 16
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "retailing and wholesaling in shops, via global computer networks, via catalogue, via post, via telephone, via radio and television and via other electronic media of preparations for stiffening whipped cream, sushi, natural sweeteners, thickening agents for cooking foodstuffs, wheat germ for human consumption, raw and unprocessed agricultural, aquacultural, horticultural and forestry products, live animals, fresh fruits and vegetables",
            "highlighted": "retailing and wholesaling in shops, via global computer networks, via catalogue, via post, via telephone, via radio and television and via other electronic media of preparations for stiffening whipped cream, <em>sushi</em>, natural sweeteners, thickening agents for cooking foodstuffs, wheat germ for human consumption, raw and unprocessed agricultural, aquacultural, horticultural and forestry products, live animals, fresh fruits and vegetables"
        },
        {
            "NiceClass": 30,
            "term": "sushi rice",
            "nbTotalOccurences": 31,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 10
                },
                {
                    "office": "MY",
                    "value": 0
                },
                {
                    "office": "NZ",
                    "value": 0
                },
                {
                    "office": "AU",
                    "value": 1
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 6
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 4
                },
                {
                    "office": "EM",
                    "value": 10
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "sushi rice",
            "highlighted": "<em>sushi</em> rice"
        },
        {
            "NiceClass": 35,
            "term": "wholesale services, retail services and online retail services connected with the sale of oatmeal, palm sugar, pancakes, pasta, pasta sauce, pasties, pastry, peanut confectionery, pepper, peppermint sweets, peppers (seasonings), pesto (sauce), pies, pizzas, popcorn, pralines, puddings, quiches, ravioli, relish (condiment), rice cakes, royal jelly, rusks, sago, sandwiches, sauces (condiments), seasonings, semolina, sorbets (ices), soya sauce, spaghetti, spring rolls, sugar, sushi",
            "nbTotalOccurences": 31,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 18
                },
                {
                    "office": "MY",
                    "value": 0
                },
                {
                    "office": "NZ",
                    "value": 0
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 0
                },
                {
                    "office": "EM",
                    "value": 13
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "wholesale services, retail services and online retail services connected with the sale of oatmeal, palm sugar, pancakes, pasta, pasta sauce, pasties, pastry, peanut confectionery, pepper, peppermint sweets, peppers (seasonings), pesto (sauce), pies, pizzas, popcorn, pralines, puddings, quiches, ravioli, relish (condiment), rice cakes, royal jelly, rusks, sago, sandwiches, sauces (condiments), seasonings, semolina, sorbets (ices), soya sauce, spaghetti, spring rolls, sugar, sushi",
            "highlighted": "wholesale services, retail services and online retail services connected with the sale of oatmeal, palm sugar, pancakes, pasta, pasta sauce, pasties, pastry, peanut confectionery, pepper, peppermint sweets, peppers (seasonings), pesto (sauce), pies, pizzas, popcorn, pralines, puddings, quiches, ravioli, relish (condiment), rice cakes, royal jelly, rusks, sago, sandwiches, sauces (condiments), seasonings, semolina, sorbets (ices), soya sauce, spaghetti, spring rolls, sugar, <em>sushi</em>"
        },
        {
            "NiceClass": 30,
            "term": "vegetarian sushi",
            "nbTotalOccurences": 30,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 6
                },
                {
                    "office": "MY",
                    "value": 0
                },
                {
                    "office": "NZ",
                    "value": 2
                },
                {
                    "office": "AU",
                    "value": 5
                },
                {
                    "office": "SG",
                    "value": 1
                },
                {
                    "office": "US",
                    "value": 4
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 7
                },
                {
                    "office": "EM",
                    "value": 5
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "vegetarian sushi",
            "highlighted": "vegetarian <em>sushi</em>"
        },
        {
            "NiceClass": 30,
            "term": "nigiri sushi",
            "nbTotalOccurences": 30,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 0
                },
                {
                    "office": "MY",
                    "value": 7
                },
                {
                    "office": "NZ",
                    "value": 19
                },
                {
                    "office": "AU",
                    "value": 1
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 1
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 2
                },
                {
                    "office": "EM",
                    "value": 0
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 1,
            "typeString": "mgs",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "nigiri sushi",
            "highlighted": "nigiri <em>sushi</em>"
        },
        {
            "NiceClass": 21,
            "term": "sushi rolling mat, bento boxes",
            "nbTotalOccurences": 29,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 17
                },
                {
                    "office": "MY",
                    "value": 0
                },
                {
                    "office": "NZ",
                    "value": 0
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 3
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 0
                },
                {
                    "office": "EM",
                    "value": 9
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "sushi rolling mat, bento boxes",
            "highlighted": "<em>sushi</em> rolling mat, bento boxes"
        },
        {
            "NiceClass": 35,
            "term": "retail services and online retail services connected with the sale of star aniseed, starch for food, stick liquorice (confectionery), sugar, sushi, sweetmeats (candy), tabbouleh, tacos, tapioca, tapioca flour for food, tarts, tea, tea-based beverages, thickening agents for cooking foodstuffs, tomato sauce, tortillas, turmeric for food, unleavened bread, unroasted coffee, vanilla (flavoring) (flavouring) and vanillin (vanilla substitute)",
            "nbTotalOccurences": 29,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 8
                },
                {
                    "office": "MY",
                    "value": 0
                },
                {
                    "office": "NZ",
                    "value": 0
                },
                {
                    "office": "AU",
                    "value": 8
                },
                {
                    "office": "SG",
                    "value": 3
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 1
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 0
                },
                {
                    "office": "EM",
                    "value": 9
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "retail services and online retail services connected with the sale of star aniseed, starch for food, stick liquorice (confectionery), sugar, sushi, sweetmeats (candy), tabbouleh, tacos, tapioca, tapioca flour for food, tarts, tea, tea-based beverages, thickening agents for cooking foodstuffs, tomato sauce, tortillas, turmeric for food, unleavened bread, unroasted coffee, vanilla (flavoring) (flavouring) and vanillin (vanilla substitute)",
            "highlighted": "retail services and online retail services connected with the sale of star aniseed, starch for food, stick liquorice (confectionery), sugar, <em>sushi</em>, sweetmeats (candy), tabbouleh, tacos, tapioca, tapioca flour for food, tarts, tea, tea-based beverages, thickening agents for cooking foodstuffs, tomato sauce, tortillas, turmeric for food, unleavened bread, unroasted coffee, vanilla (flavoring) (flavouring) and vanillin (vanilla substitute)"
        },
        {
            "NiceClass": 30,
            "term": "norimaki sushi",
            "nbTotalOccurences": 28,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 0
                },
                {
                    "office": "MY",
                    "value": 6
                },
                {
                    "office": "NZ",
                    "value": 18
                },
                {
                    "office": "AU",
                    "value": 1
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 1
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 2
                },
                {
                    "office": "EM",
                    "value": 0
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 1,
            "typeString": "mgs",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "norimaki sushi",
            "highlighted": "norimaki <em>sushi</em>"
        },
        {
            "NiceClass": 35,
            "term": "sushi",
            "nbTotalOccurences": 25,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 11
                },
                {
                    "office": "MY",
                    "value": 2
                },
                {
                    "office": "NZ",
                    "value": 0
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 0
                },
                {
                    "office": "EM",
                    "value": 12
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "sushi",
            "highlighted": "<em>sushi</em>"
        },
        {
            "NiceClass": 30,
            "term": "temaki sushi",
            "nbTotalOccurences": 24,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 0
                },
                {
                    "office": "MY",
                    "value": 8
                },
                {
                    "office": "NZ",
                    "value": 12
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 1
                },
                {
                    "office": "US",
                    "value": 1
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 2
                },
                {
                    "office": "EM",
                    "value": 0
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 1,
            "typeString": "mgs",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "temaki sushi",
            "highlighted": "temaki <em>sushi</em>"
        },
        {
            "NiceClass": 30,
            "term": "maki sushi",
            "nbTotalOccurences": 24,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 0
                },
                {
                    "office": "MY",
                    "value": 8
                },
                {
                    "office": "NZ",
                    "value": 14
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 2
                },
                {
                    "office": "EM",
                    "value": 0
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 1,
            "typeString": "mgs",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "maki sushi",
            "highlighted": "maki <em>sushi</em>"
        },
        {
            "NiceClass": 30,
            "term": "sushi seasoning",
            "nbTotalOccurences": 23,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 3
                },
                {
                    "office": "MY",
                    "value": 4
                },
                {
                    "office": "NZ",
                    "value": 2
                },
                {
                    "office": "AU",
                    "value": 2
                },
                {
                    "office": "SG",
                    "value": 6
                },
                {
                    "office": "US",
                    "value": 2
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 2
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 2
                },
                {
                    "office": "EM",
                    "value": 0
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "sushi seasoning",
            "highlighted": "<em>sushi</em> seasoning"
        },
        {
            "NiceClass": 30,
            "term": "uramaki sushi",
            "nbTotalOccurences": 22,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 0
                },
                {
                    "office": "MY",
                    "value": 7
                },
                {
                    "office": "NZ",
                    "value": 12
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 1
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 2
                },
                {
                    "office": "EM",
                    "value": 0
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 1,
            "typeString": "mgs",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "uramaki sushi",
            "highlighted": "uramaki <em>sushi</em>"
        },
        {
            "NiceClass": 30,
            "term": "futomaki sushi",
            "nbTotalOccurences": 22,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 0
                },
                {
                    "office": "MY",
                    "value": 8
                },
                {
                    "office": "NZ",
                    "value": 12
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 2
                },
                {
                    "office": "EM",
                    "value": 0
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 1,
            "typeString": "mgs",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "futomaki sushi",
            "highlighted": "futomaki <em>sushi</em>"
        },
        {
            "NiceClass": 21,
            "term": "sushi rollers",
            "nbTotalOccurences": 21,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 2
                },
                {
                    "office": "MY",
                    "value": 1
                },
                {
                    "office": "NZ",
                    "value": 1
                },
                {
                    "office": "AU",
                    "value": 1
                },
                {
                    "office": "SG",
                    "value": 1
                },
                {
                    "office": "US",
                    "value": 1
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 7
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 5
                },
                {
                    "office": "EM",
                    "value": 2
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 1,
            "typeString": "mgs",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "sushi rollers",
            "highlighted": "<em>sushi</em> rollers"
        },
        {
            "NiceClass": 30,
            "term": "hosomaki sushi",
            "nbTotalOccurences": 20,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 0
                },
                {
                    "office": "MY",
                    "value": 6
                },
                {
                    "office": "NZ",
                    "value": 12
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 2
                },
                {
                    "office": "EM",
                    "value": 0
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 1,
            "typeString": "mgs",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "hosomaki sushi",
            "highlighted": "hosomaki <em>sushi</em>"
        },
        {
            "NiceClass": 35,
            "term": "mail order retail services in relation to sushi",
            "nbTotalOccurences": 20,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 3
                },
                {
                    "office": "MY",
                    "value": 0
                },
                {
                    "office": "NZ",
                    "value": 0
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 3
                },
                {
                    "office": "EM",
                    "value": 14
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "mail order retail services in relation to sushi",
            "highlighted": "mail order retail services in relation to <em>sushi</em>"
        }
    ],
    "startYear": 2012,
    "endYear": 0,
    "version": "2.0",
    "original_term": "sushi"
}